var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHorizontalLayoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.25L15.2646 5.25C15.858 5.25011 16.4273 5.48454 16.8486 5.90234L20.585 9.60937C21.0107 10.0318 21.25 10.6073 21.25 11.207L21.25 16.5C21.25 17.7426 20.2426 18.75 19 18.75L6 18.75C4.75736 18.75 3.75 17.7426 3.75 16.5L3.75 7.5C3.75 6.25736 4.75736 5.25 6 5.25Z",
    fill: "white",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 5L15.5 10C15.5 10.5523 15.9477 11 16.5 11L21.5 11",
    stroke: "#1A1B1D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHorizontalLayoutIcon);
export default __webpack_public_path__ + "static/media/horizontal-layout-icon.3f789242308284ac3afcea3b1be1d2d9.svg";
export { ForwardRef as ReactComponent };